import { ToggleButton, ToggleButtonGroup, styled, useTheme } from "@mui/material";
import { t } from "i18next";
import { EGroup } from "../../../pages/Home";

type Props = {
  value: EGroup;
  onChange: (value: EGroup) => void;
};

const GroupToggleButton = (props: Props) => {
  const theme = useTheme();

  const CustomToggleButton = styled(ToggleButton)({
    background: theme.palette.base.main,
    color: theme.palette.base.contrast,
    "&.Mui-selected": {
      background: theme.palette.base.ymdBackground,
      color: "#FFFFFF",
    },
    "&.Mui-selected:hover": {
      background: theme.palette.base.ymdBackground,
      color: "#FFFFFF",
    },
  });

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={props.value}
      onChange={(e, v) => {props.onChange(v)}}
      sx={{height: "40px", borderRadius: "0px"}}
    >
      <CustomToggleButton
        value={EGroup.YEAR}
        sx={{minWidth: "40px", borderRadius: "0px"}}
      >
        {t("YEAR")}
      </CustomToggleButton>
      <CustomToggleButton
        value={EGroup.MONTH}
        sx={{minWidth: "40px", borderRadius: "0px"}}
      >
        {t("MONTH")}
      </CustomToggleButton>
      <CustomToggleButton
        value={EGroup.DAY}
        sx={{minWidth: "40px", borderRadius: "0px"}}
      >
        {t("DAY")}
      </CustomToggleButton>
    </ToggleButtonGroup>
  );
};

export default GroupToggleButton;
